import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'datepipe'
})
export class DateFormatPipe implements PipeTransform {
    transform(value: string, args?: any): any {
        return moment(Date.parse(value)).format('MM-DD-YYYY');
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/dateFormat.pipe.ts